import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
import { nextTick } from 'vue';
import { ValidationField } from '@/components/ui/validate-form';
import { trlMessage } from '@/services/i18n';
import ValidationErrors from '@/components/ui/validation-errors.vue';
import { UiInput, UiStack } from '@huntflow/ui';
import { mask as vMask } from 'vue-the-mask';
export default /*@__PURE__*/ _defineComponent({
    __name: 'organization',
    setup(__props) {
        const numericField = {
            type: 'text',
            inputMode: 'numeric'
        };
        const orgFields = [
            {
                id: 'organization.legal_name',
                title: trlMessage('organization.name'),
                class: 'full'
            },
            {
                id: 'organization.inn',
                title: trlMessage('organization.inn'),
                class: 'col',
                ...numericField,
                mask: '############'
            },
            {
                id: 'organization.kpp',
                title: trlMessage('organization.kpp'),
                class: 'col',
                ...numericField,
                mask: '#########'
            },
            {
                id: 'organization.ogrn',
                title: trlMessage('organization.ogrn'),
                class: 'col',
                ...numericField,
                mask: '#############'
            },
            {
                id: 'organization.legal_address',
                title: trlMessage('organization.address.legal'),
                class: 'full'
            },
            {
                id: 'organization.actual_address',
                title: trlMessage('organization.address.actual'),
                class: 'full'
            },
            {
                id: 'organization.bank_name',
                title: trlMessage('organization.bank.name'),
                class: 'half'
            },
            {
                id: 'organization.bic',
                title: trlMessage('organization.bic'),
                class: 'half',
                ...numericField,
                mask: '#########'
            },
            {
                id: 'organization.account',
                title: trlMessage('organization.account'),
                class: 'half',
                ...numericField,
                mask: '####################'
            },
            {
                id: 'organization.correspondent_account',
                title: trlMessage('organization.correspondent'),
                class: 'half',
                ...numericField,
                mask: '####################'
            }
        ];
        function focusField(fieldId) {
            nextTick(() => document.getElementById(fieldId)?.focus());
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style.root)
            }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orgFields, (field) => {
                    return _createVNode(_unref(ValidationField), {
                        key: field.id,
                        name: field.id,
                        onShouldFocus: ($event) => (focusField(field.id))
                    }, {
                        default: _withCtx(({ modelValue, onChange, name, invalid }) => [
                            _createElementVNode("div", {
                                class: _normalizeClass(field.class ? _ctx.$style[field.class] : '')
                            }, [
                                _createVNode(_unref(UiStack), {
                                    gap: "xs",
                                    size: "full",
                                    direction: "column"
                                }, {
                                    default: _withCtx(() => [
                                        (field.mask)
                                            ? _withDirectives((_openBlock(), _createBlock(_unref(UiInput), {
                                                key: 0,
                                                id: field.id,
                                                title: field.title,
                                                name: name,
                                                type: field.type,
                                                inputmode: field.inputMode,
                                                error: invalid,
                                                "model-value": modelValue,
                                                "onUpdate:modelValue": onChange
                                            }, null, 8, ["id", "title", "name", "type", "inputmode", "error", "model-value", "onUpdate:modelValue"])), [
                                                [_unref(vMask), field.mask]
                                            ])
                                            : (_openBlock(), _createBlock(_unref(UiInput), {
                                                key: 1,
                                                id: field.id,
                                                title: field.title,
                                                name: name,
                                                error: invalid,
                                                "model-value": modelValue,
                                                "onUpdate:modelValue": onChange
                                            }, null, 8, ["id", "title", "name", "error", "model-value", "onUpdate:modelValue"])),
                                        invalid
                                            ? (_openBlock(), _createBlock(ValidationErrors, {
                                                key: 2,
                                                name: field.id
                                            }, null, 8, ["name"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1024)
                            ], 2)
                        ]),
                        _: 2
                    }, 1032, ["name", "onShouldFocus"]);
                }), 64))
            ], 2));
        };
    }
});
